export const getInitialState = () => ({
  init: ''
});
